import React, { useState } from "react";
import ApiMappingTable from "components/ApiMappingTable";
import ShelterBuddyApiMappingTable from "components/ShelterBuddyApiMappingTable";

export default function ApiMapping({ orgApiProvider }) {
  const [formMode, setFormMode] = useState("VIEW");

  return (
    <div>
      {orgApiProvider === "ShelterBuddy" ? (
        <ShelterBuddyApiMappingTable
          formMode={formMode}
          setFormMode={setFormMode}
        />
      ) : (
        <ApiMappingTable formMode={formMode} setFormMode={setFormMode} />
      )}
    </div>
  );
}
